import React, { createRef, useEffect, useLayoutEffect, useRef, useState, useReducer } from 'react';
import { createMuiTheme, Fab, makeStyles, MuiThemeProvider, Paper, Radio, Tab, TableCell, Tabs, TextField, Typography, FormGroup } from "@material-ui/core";
import MUIDataTable from 'mui-datatables';
import { withStyles } from '@material-ui/styles';
import { green } from '@material-ui/core/colors';
import api from "../api";
import { KeyboardDatePicker, MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { format } from 'date-fns';
import DateFnsUtils from "@date-io/date-fns";
// import CloseImage from '../../assets/ic_close.png';

const pageStyle = `{size: 3.075in 10.25in}`;
const pageStyleTiket = `{size: 5cm 7.3cm}`;

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()

const GreenRadio = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

const style = {
    position: "sticky",
    zIndex: 110
};

export default function RiwayatHasilRadiologi(props) {
    const [dataTable, setDataTable] = useState([]);
    const [open, setOpen] = useState(false);
    const [validFrom, setValidFrom] = useState(null);
    const [validTo, setValidTo] = useState(null);
    const [dataFilter, setDataFilter] = useState(null);
    const wrapperRef = createRef()

    useEffect(() => {
        props.setShowNotif(true)
        getDataTable()
    }, [])

    const getDataTable = () => {
        api.create().getListHistoryRadiologi().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let dataTable = response.data.data && response.data.data.map((item, index) => {
                        console.log(item);
                        return [
                            item.production_date,
                            item.production_date,
                            item.queue_number,
                            item.patient_name === null ? item.patient_name_2 : item.patient_name,
                            item.patient_date_of_birth,
                            item.patient_medical_record_no === null ? item.patient_medical_record_no_2 : item.patient_medical_record_no,
                            item.facility.name,
                            item.polyclinic_name === null ? item.polyclinic_name_2 : item.polyclinic_name,
                            item.doctor_name === null ? item.doctor_name_2 : item.doctor_name,
                            item.payment_option_name,
                            item.notes,
                            item.status_name,
                            item.id
                        ]
                    })
                    setDataTable(dataTable || [])
                }
            }
        })
    }

    const columns =
        [
            {
                label: "Tanggal",
                options: {
                    filter: true,
                    filterType: 'custom',
                    onTableChange: console.log,
                    resetFilter: () => {
                        console.log('masuk');
                    },
                    onFilterChange: (columnChanged, filterList) => {
                        console.log(`onFilterChange columnChanged: ${columnChanged}`);
                        console.log(filterList);
                    },
                    filterOptions: {
                        names: [],
                        logic(age, filters) {
                            if (filters[0] && filters[1]) {
                                return age < filters[0] || age > filters[1];
                            } else if (filters[0]) {
                                return age < filters[0];
                            } else if (filters[1]) {
                                return age > filters[1];
                            }
                            return false;
                        },
                        display: (filterList, onChange, index, column) => (
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        margin="normal"
                                        label="Tgl. Reservasi Awal"
                                        format="dd/MM/yyyy"
                                        clearable
                                        value={validFrom}
                                        maxDate={validTo && validTo}
                                        onChange={(date) => {
                                            console.log(date);
                                            setValidFrom(date)
                                            if (validTo === null) {
                                                setValidTo(date)
                                            }
                                            date === null ? updateDateRange(format(new Date(), 'yyyyMMdd'), validTo === null ? format(new Date(date), 'yyyyMMdd') : format(new Date(validTo), 'yyyyMMdd')) : updateDateRange(format(new Date(date), 'yyyyMMdd'), validTo === null ? format(new Date(date), 'yyyyMMdd') : format(new Date(validTo), 'yyyyMMdd'))
                                            // forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        ),
                    },
                    customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                        <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white', }}>
                            <Typography style={{ fontSize: '12pt', textAlign: 'left', color: '#2a9c6c', fontWeight: 600 }}>{columnMeta.label}</Typography>
                        </TableCell>
                    ),
                    customBodyRender: (val, tableMeta) => {
                        return (
                            <div style={{ display: 'flex', textAlign: 'start', width: 77, }}>
                                {/* <Typography> */}
                                {val}
                                {/* </Typography> */}
                            </div>
                        )
                    }
                }
            },
            {
                name: "",
                options: {
                    display: false,
                    filterType: 'custom',
                    filterOptions: {
                        names: [],
                        logic(age, filters) {
                            if (filters[0] && filters[1]) {
                                return age < filters[0] || age > filters[1];
                            } else if (filters[0]) {
                                return age < filters[0];
                            } else if (filters[1]) {
                                return age > filters[1];
                            }
                            return false;
                        },
                        display: (filterList, onChange, index, column) => (
                            <div>
                                <FormGroup column>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <DatePicker
                                            margin="normal"
                                            clearable
                                            label="Tgl. Reservasi Akhir"
                                            format="dd/MM/yyyy"
                                            maxDate={new Date()}
                                            minDate={validFrom && validFrom}
                                            value={validTo}
                                            onChange={(date) => {
                                                setValidTo(date)
                                                if (validFrom === null && date !== null) {
                                                    setValidFrom(new Date())
                                                }
                                                if (date === null) {
                                                    getDataTable()
                                                    setDataFilter(null)
                                                } else {
                                                    updateDateRange(validFrom === null ? format(new Date(), 'yyyyMMdd') : format(new Date(validFrom), 'yyyyMMdd'), format(new Date(date), 'yyyyMMdd'))
                                                }
                                                // forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '100%' }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </FormGroup>
                            </div>
                        ),
                    }
                }
            }, "No. Antrian", "Nama Pasien", "Tanggal Lahir", "No RM", "Fasilitas", "Klinik", "Dokter", "Opsi Pembayaran", "Catatan Petugas", "Status",
        ];

    const updateDateRange = (a, b) => {
        // console.log(a, b);
        const c = dataTable.filter((item) => {
            // console.log(Number(format(new Date(item[8]), 'yyyyMMdd')));
            return Number(format(new Date(item[0]), 'yyyyMMdd')) >= Number(a) && Number(format(new Date(item[0]), 'yyyyMMdd')) <= Number(b)
        });
        setDataFilter(c)
        forceUpdate()
    }

    const forceUpdate = useReducer(bool => !bool)[1];

    return (
        <div>
            <div style={{}}>
                <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', marginTop: 20, padding: 10, zIndex: 2 }} >
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={dataTable}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </Paper>
            </div>
        </div>
    )
}
